// src/ProtectedProjectDetail.js
import React from "react";
import { useParams, Navigate } from "react-router-dom";
import ProjectDetail from "./pages/ProjectDetail";

const allowedByProject = {
  // projectId -> roles allowed
  panel: ["admin", "usuario"],       // panel accesible por admin y usuario
  mapeo: ["admin", "usuario"],       // mapeo accesible por admin y usuario
  cubo: ["admin", "analista"]        // cubo accesible por admin y analista
};

const ProtectedProjectDetail = () => {
  const { projectId } = useParams();
  let parsedUser = null;
  const storedUser = localStorage.getItem("user");
  if (storedUser) {
    try {
      parsedUser = JSON.parse(storedUser);
    } catch (error) {
      console.error("Error al leer el usuario desde localStorage", error);
    }
  }
  const role = parsedUser?.role || localStorage.getItem("role") || null;

  // Si no hay rol en frontend, redirigimos al login
  if (!role) {
    return <Navigate to="/" replace />;
  }

  const allowed = allowedByProject[projectId] || [];

  if (!allowed.includes(role)) {
    return <Navigate to="/acceso-denegado" replace />;
  }

  // Si está permitido, renderiza el ProjectDetail normal
  return <ProjectDetail />;
};

export default ProtectedProjectDetail;
